import React from 'react'
import PropTypes from 'prop-types'
import { useDispatch } from 'react-redux'
import { makeStyles } from '@mui/styles'
import { Tooltip } from '@mui/material'
import clsx from 'clsx'
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch'

import { hideContextMenu } from '@/redux/ducks/listContextMenu'

const useStyles = makeStyles((theme) => ({
  item: (props) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: props.subLabel ? 'space-between' : 'unset',
    width: '100%',
    cursor: 'pointer',
    color: theme.black1,
    fontSize: 14,
    borderLeft: '3px solid transparent',
    borderTop: '1px solid transparent',
    borderBottom: '1px solid transparent',
    padding: 15,
    lineHeight: '1rem',
    '&:hover:not($disabled)': {
      borderColor: theme.borderColor,
      borderLeftColor: theme.primary,
      background: '#f6f7fd',
    },
  }),
  disabled: {
    color: theme.lightGrey,
    cursor: 'default',
    '& $icon svg > *': {
      fill: theme.lightGrey,
    },
  },
  lockedContent: {
    opacity: '50%',
  },
  icon: {
    height: 14,
    paddingRight: 15,
  },
  subLabel: {
    fontSize: 8,
  },
  iconContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: theme.lightBackground,
    padding: 4,
    borderRadius: 8,
    marginLeft: 12,
  },
  rocketIcon: {
    fontSize: theme.fontSizes.smedium,
    color: theme.primary,
    height: 12,
    width: 12,
  },
}))

const ContextMenuItem = (props) => {
  const { label, icon, onItemClick, iconCustomStyle, labelCustomStyle, disabled, className, subLabel, tooltipText, locked } = props
  const classes = useStyles(props)
  const dispatch = useDispatch()
  const iconEl = icon && <span className={clsx(classes.icon, iconCustomStyle)}>{icon}</span>

  const onClick = () => {
    onItemClick && onItemClick()
    dispatch(hideContextMenu())
  }

  const isDisabled = disabled && !locked

  const menuItem = (
    <li className={clsx(classes.item, className, isDisabled && classes.disabled)} onClick={onClick}>
      <div className={locked && classes.lockedContent} style={{ display: 'flex', alignItems: 'center', flex: 1 }}>
        {iconEl}
        <div className={clsx(labelCustomStyle)}>{label}</div>{subLabel ? <div className={classes.subLabel}>{subLabel}</div> : null}
      </div>
      {locked && (
        <div className={classes.iconContainer}>
          <RocketLaunchIcon className={classes.rocketIcon} />
        </div>
      )}
    </li>
  )

  // Wrap with tooltip if tooltipText is provided
  if (tooltipText) {
    return (
      <Tooltip title={tooltipText} placement="right" arrow>
        {menuItem}
      </Tooltip>
    )
  }

  return menuItem
}

ContextMenuItem.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  icon: PropTypes.any,
  label: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]),
  subLabel: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]),
  onItemClick: PropTypes.func,
  iconCustomStyle: PropTypes.string,
  labelCustomStyle: PropTypes.string,
  tooltipText: PropTypes.string,
  locked: PropTypes.bool,
}

ContextMenuItem.defaultProps = {
  disabled: false,
}

export default ContextMenuItem
